<template>
  <generic-modal
    size
    :title="$t('card')"
    icon="credit card"
    image="/images/icons/credit_card.png"
    v-on:destroy="destroy"
    :on_finished="finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("account finder") }}</label>
            <div class="ui blue search" ref="account_search">
              <div class="ui icon input">
                <input
                  class="prompt"
                  type="text"
                  name="account"
                  v-model="account.number"
                  :placeholder="$t('search account')"
                />
                <i class="search icon"></i>
              </div>
              <div class="results"></div>
            </div>
            <div class="field" style="margin-top:15px">
              <label for>{{ $t("card type") }}</label>
              <div class="ui search selection dropdown" ref="types_dropdown">
                <input type="hidden" name="type" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div>
            </div>
            <div class="field" style="margin-top:15px">
              <label for>{{ $t("name") }}</label>
              <input type="text" name="name" v-model="name" />
            </div>
            <div class="field" style="margin-top:15px">
              <label for>{{ $t("number") }}</label>
              <input type="text" name="number" v-model="number" />
            </div>
          </div>
          <div class="field">
            <div class="ui horizontal cards" v-if="account">
              <div class="card">
                <div class="image">
                  <img src="/images/icons/matthew.png" />
                </div>
                <div class="content">
                  <div class="header">{{ account.name }}</div>
                  <div class="meta">
                    <a>{{ account.number }}</a>
                  </div>
                  <div class="description">
                    <!-- <pre>{{ student }}</pre> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui message error"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, stringify, init_search } from "@/utils";
import GenericModal from "@/components/GenericModal";
import filters from "@/filters";

export default {
  name: "TransactionModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
  },
  props: {
    account_in: Object,
    card_in: Object,
  },
  computed: {},
  data() {
    return {
      account: {},
      card_types: [],
      transactions: [],
      card_type: "",
      selected_card_type: undefined,
      name: "0",
      number: "0",
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      window.jQuery(this.$refs.form).form("validate form");
      let isValid = window.jQuery(this.$refs.form).form("is valid");
      let vm = this;
      return new Promise((resolve, reject) => {
        if (isValid) {
          local_api(vm, "post", "/account_card/do-save", {
            a: vm.account.uuid,
            u: vm.card_in ? vm.card_in.uuid : null,
            t: vm.card_type,
            n: vm.name,
            m: vm.number,
            // s: JSON.stringify({ receipt: vm.receipt }),
          })
            .then((response) => {
              vm.$emit("succedded", response);
              resolve(response);
            })
            .catch((err) => {
              window.jQuery(this.$refs.form).form("add errors", [err]);
              reject(err);
            });
        } else {
          reject();
        }
      });
    },
  },
  created() {
    let vm = this;
    if (vm.account_in) vm.account = vm.account_in;

    local_api(vm, "post", "/account_card_type/do-get-list", {})
      .then((types) => {
        vm.card_types = types.map((t) => {
          t.setup = JSON.parse(t.setup);
          return t;
        });

        window
          .jQuery(vm.$refs.types_dropdown)
          .dropdown("setup menu", {
            values: vm.card_types.map((p) => {
              return {
                name: p.name,
                value: p.type_id,
              };
            }),
          })
          .dropdown({
            onChange(value) {
              vm.card_type = value;
              vm.selected_card_type = vm.card_types.find(
                (n) => n.type_id == value,
              );
            },
          });

        if (vm.card_in && vm.card_in.type_id) {
          vm.card_type = vm.card_in.type_id;
          window
            .jQuery(vm.$refs.types_dropdown)
            .dropdown("set selected", vm.card_in.type_id);
        }
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
  mounted() {
    let vm = this;

    if (vm.card_in && vm.card_in.name) vm.name = vm.card_in.name;
    if (vm.card_in && vm.card_in.number) vm.number = vm.card_in.number;

    window.jQuery(vm.$refs.form).form({
      fields: {
        type: ["empty"],
        name: ["empty"],
        number: ["empty", "creditCard"],
      },
    });

    let onSearchResponse = (data) => {
      let rslt = [];
      data.map((r) => {
        rslt.push({
          title: r.name,
          description: r.number,
          account: r,
        });
      });
      return { results: rslt };
    };
    let onSearchSelect = (data) => {
      vm.account = data.account;
    };

    init_search(
      vm,
      this.$refs.account_search,
      "search account",
      onSearchResponse,
      onSearchSelect,
    );
  },
  watch: {},
};
</script>
